export default import.meta.ROLLDOWN_FILE_URL_x7E_vqcf4zfljj3$lwQGUg